import React from "react";
import { Query } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { Select } from "antd";
import PageLoader from "../PageLoader";
import { statusIcon, agentStatus } from "../../lib/status";

const AGENTS_QUERY = gql`
  query agentsQuery {
    agents {
      id
      token
      name
      lastCheckInAt
    }
  }
`;

const { Option } = Select;

type AgentSelectProps = {
  onChange?: any;
  value?: string;
};

export default class AgentSelect extends React.Component<AgentSelectProps> {
  agentSelectOptions(agents: any[]): JSX.Element[] {
    let options = [];
    if (agents) {
      agents.forEach((agent) => {
        let agentName = agent.name || agent.id;
        options.push(
          <Option title={agentName} value={agent.token} key={agent.id}>
            {statusIcon(agentStatus(agent), "small")}&nbsp; &nbsp; {agentName}
          </Option>,
        );
      });
    }
    return options;
  }

  render() {
    return (
      <Query query={AGENTS_QUERY}>
        {({ loading, data }) => {
          if (loading) {
            return <PageLoader tip="Loading..." delay={500} />;
          }

          data.agents.slice().sort((a, b) => a.name.localeCompare(b.name));

          return (
            <Select
              showSearch
              key="agentId"
              optionFilterProp="children"
              value={this.props.value}
              onChange={this.props.onChange}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.agentSelectOptions(data.agents)}
            </Select>
          );
        }}
      </Query>
    );
  }
}
